<h1>My Dashboards</h1>

<div style="clear:both"></div>  <!-- puts items in following div on new lines -->
<div id="wrapper">

<div id="left">
<div class="row leftIndent">

	<!--
	--		View existing dashboards
	-->
	<h2>View Existing Dashboards</h2>
	<h4 class="leftSpace">Click a dashboard title listed below <span class="bold">My Dashboards</span> on the main application menu to view an existing dashboard.</h4>

	<!--
	--		Existing dashboard list
	-->
	<h2 class="moreTopSpace">Edit Existing Dashboards</h2>
  	<div id="templateInformation">
  		<div class="col-md-4 form-group pulldownText" style="float:left; padding-left:10px; padding-top: 5px" id="existingTemplateDropdown">
			<p-select [options]="templateList" 
				[(ngModel)]="existingTemplate" 
				[style]="{'width':'300px'}" 
				(ngModelChange)="existingTemplateSelected($event)" 
				[filter]="true" 
				data-cy="editExistingTemplate"
				placeholder="Select existing template to edit">
				<ng-template let-templateId pTemplate="item">
					<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
		            			<div>{{templateId.label}}</div>
		        		</div>
				</ng-template>
			</p-select>
		</div>
  	</div>

	<!--
	--		Delete dashboard
	-->
  	<div style="clear:left"></div>
	<h2>Delete Dashboard</h2>
  	<div id="templateDeleteInformation">
  		<div class="col-md-4 form-group pulldownText" style="float:left; padding-left:10px; padding-top: 5px" id="existingTemplateDropdown">
			<p-select [options]="templateList" 
				[(ngModel)]="existingTemplateDelete" 
				[style]="{'width':'300px'}" 
				(ngModelChange)="existingTemplateSelectedToDelete($event)" 
				[filter]="true" 
				data-cy="deleteTemplate"
				placeholder="Select existing template to delete">

				<ng-template let-templateId pTemplate="item">
					<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
		            	<div>{{templateId.label}}</div>
		        	</div>
				</ng-template>
			</p-select>
			<div id="deleteExtras">
				<button pButton pRipple [ngClass]="{hidden:systemDashboardDeleteWarningVisible}"
					label="{{deleteButtonLabel}}" 
					class="topSpace p-mr-2" 
					(click)="deleteDashboard()"
					icon="pi pi-trash">
				</button>

				<p-message [ngClass]="{hidden:!systemDashboardDeleteWarningVisible}" severity="warn"
					class="topSpace"
					text="System-wide custom dashboards cannot be deleted.">
				</p-message>
			</div>
		</div>
  	</div>

  	<!-- 
  	-- 		Create a new dashboard section
  	-->
  	<div style="clear:left"></div>
  	<h2>Create a New Dashboard</h2>
		<div class="col-md-4 form-group pulldownText" style="float:left; padding-left:10px; padding-top: 5px" id="selTemplateUseCase">
			<p-select [options]="useCases" [(ngModel)]="selectedUseCase" [style]="{'width':'600px'}" data-cy="createNewDashboard"
				(ngModelChange)="useCaseSelected($event)" [filter]="false" 
				placeholder="Select dashboard strategy">

				<ng-template let-useCase pTemplate="item">
					<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
		            	<div>{{useCase.label}}</div>
		        	</div>
				</ng-template>
			</p-select>
		</div>

		<!-- 
		--		Area for new dashboard title and existing dashboard list for copying
		-->
		<div id="dashboardContentDiv" style="clear: left" class="goodTextSize">
			<div id="dashboardTitleDiv">Dashboard Title 
				<input type="text" pInputText 
					[(ngModel)]="dashboardTitle" 
					data-cy="templateDashboardTitle"
					[ngClass]="{invalid:templateNameWarningVisible}" 
					(keyup)="enteringTemplateName()"/>
				<p-message [ngClass]="{hidden:!templateNameWarningVisible}" severity="error" text="Field is required"></p-message>
				<p-message [ngClass]="{hidden:!idAlreadyInUseVisible}" severity="error" text="Dashboard name must be unique"></p-message>

				<span id="existingTemplateList" class="topSpace leftSpace" style="margin-left:10px">
					<p-select [options]="templateList" 
						[(ngModel)]="existingTemplateIdToCopy" 
						[style]="{'width':'300px'}" 
						(ngModelChange)="existingTemplateToCopySelected($event)" 
						[filter]="true" 
						placeholder="Select existing template to copy">

						<ng-template let-templateId pTemplate="item">
							<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
				            	<div>{{templateId.label}}</div>
				        	</div>
						</ng-template>
					</p-select>
				</span>
			</div>
		</div>

		<!-- 
		-- 		Work area - lists each element in the template.  Add/delete elements.
		-->
		<div id="workspace" >  <!-- class="topSpace halfWidth" -->
		<h2 id="workSpaceTitle">Edit</h2>
		<p-message [ngClass]="{hidden:!systemDashboardWarningVisible}" severity="warn" text="System-wide custom dashboards cannot be edited.  Changes will not be saved."></p-message>

		<!--
		--	template-wide preferences
		-->
		<div style="clear:left" class="topSpace">
			<div>  <!-- filter stations list -->
				Filter station list:
				<p-select [options]="stationFilterOptions" 
					[(ngModel)]="stationFilter" 
					(ngModelChange)="stationFilterChanged($event)" 
					class="leftSpace" >
				</p-select>
				<input type="text" pInputText [ngClass]="{hidden:!stationFilterVisible}"
					[(ngModel)]="stationFilterText"
					class="leftSpace" />
			</div>
		</div>

		<!--
		--	add a chart, map, images buttons
		-->
		<div style="clear:left" class="topSpace">
		<button pButton pRipple title="Add a chart" label="Add a chart" (click)="addAChart()" icon="pi pi-chart-line" data-cy="addAChart"></button>
		<button pButton pRipple title="Add a map" label="Add a map" (click)="addAMap()" icon="pi pi-globe" [disabled]=hasMap></button>
		<button pButton pRipple title="Add images" label="Add images" (click)="addImages()" icon="pi pi-image" [disabled]=hasImages></button>
		</div>

		<!--Message: dashboard saved -->
		<p-message [ngClass]="{hidden:!templateSaved}" [@buttonState]="stateDashboardSaved" severity="success" text="Dashboard saved"></p-message>

		<!-- accordion of elements -->
		<p-accordion pDroppable="ch" (onDrop)="drop($event)">
			<p-accordion-panel *ngFor="let element of templateElements; index as i" [value]="i" (onOpen) = "elementOpened(element)" pDraggable="ch" (onDragStart)="dragStart($event, element, i)" (onDragEnd)="dragEnd($event)">
				<p-accordion-header *ngIf="element.type == 'chart'">
					{{element.type}} - {{element.data[0].dataType}} - {{element.data[0].dataType}}.{{element.data[0].statisticType}}.{{element.data[0].duration}} 
						<button (click)="deleteElement(element)" class="elementButtons">
						<img title="Delete element" src="assets/images/DeleteIcon/Delete_Icon_32.png" style="float:right" width="22" height="22">
						</button>
				</p-accordion-header>
				<p-accordion-header *ngIf="element.type == 'map'">
					{{element.type}} <button (click)="deleteElement(element)" class="elementButtons">
						<img title="Delete element" src="assets/images/DeleteIcon/Delete_Icon_32.png" style="float:right" width="22" height="22">
						</button>
				</p-accordion-header>
				<p-accordion-header *ngIf="element.type == 'images'">
					{{element.type}} <button (click)="deleteElement(element)" class="elementButtons">
						<img title="Delete element" src="assets/images/DeleteIcon/Delete_Icon_32.png" style="float:right" width="22" height="22">
						</button>
				</p-accordion-header>
				<!-- element content -->
				<p-accordion-content>

					<div *ngIf="element.type == 'chart'">  <!-- [ngClass]="{hidden:!showStationSelectorOnChart}" -->
						<p-panel *ngFor="let singleTS of element.data; index as j" [toggleable]="true">  <!-- header="TS {{j+1}}" -->
							<ng-template pTemplate="header">
								<div class="tsButtonsDiv">
								<label class="tsLabel">TS {{j+1}}</label>
								<button pButton pRipple type="button" icon="pi pi-plus" (click)="addTS(element, i, j)" title="Add time series" class="p-button-rounded p-button-success p-button-outlined"> </button>
								<button pButton pRipple type="button" icon="pi pi-times" (click)="deleteTS(element, i, j)" title="Delete time series" class="p-button-rounded p-button-danger p-button-outlined"> </button>
								</div>
							</ng-template>
							<div class="col-md-12 form-group"  style="float:left; padding-left:10px; clear:right; display:block" id="selDiv">
								<p-select [options]="stationList" 
									[(ngModel)]="element.data[j].station_id" 
									[style]="{'width':'80%'}" 
									(ngModelChange)="newStationSelected($event, element, i, j)" 
									[filter]="true" 
									[showClear]="true"
									placeholder={{singleTS.station_id}}>
									<ng-template let-station pTemplate="item">
										<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
											<div class="{{station.novaScoreClass}} stationListElement">{{station.label}}</div>
										</div>
									</ng-template>
								</p-select>
								<br>(leave blank to indicate chart data can come from dynamically selected station)
							</div>
							<div style="clear:both"></div>

							<p-accordion>
								<!-- data properties -->
								<p-accordion-panel [selected]="true">
									<p-accordion-header>Data Properties</p-accordion-header>
									<p-accordion-content>
										<div class="leftIndent">
											Data Type: 
												<p-select [options]="element.data[j].dataTypes" 
													[(ngModel)]=singleTS.dataType 
													[style]="{'width':'250px'}" 
													appendTo="body"
													placeholder={{singleTS.dataType}}
													(onClick)="setElementDataTypes(element, j)" 
													(onChange)="elementDataTypeSelected($event)">
												</p-select>
												<br>
											Statistic Type:
												<p-select [options]="element.data[j].statisticTypes" 
													[(ngModel)]=singleTS.statisticType 
													[style]="{'width':'250px'}" 
													appendTo="body"
													placeholder={{singleTS.statisticType}} 
													(onClick)="setElementStatisticTypes(element, j)">
												</p-select>
												<br>
											Duration:
												<p-select [options]="element.data[j].durations" 
													[(ngModel)]=singleTS.duration
													[style]="{'width':'250px'}" 
													appendTo="body"
													placeholder={{singleTS.duration}} (onClick)="setElementDurations(element, j)">
												</p-select>
												<br>
										</div>
									</p-accordion-content>
								</p-accordion-panel>
								<!-- chart properties -->
								<p-accordion-panel>
									<p-accordion-header>Chart Properties</p-accordion-header>
									<p-accordion-content>
										<p-tabs>
											<p-tablist>
												<p-tab value="0">Basic</p-tab>
												<p-tab value="1">Legend</p-tab>
												<p-tab value="2">Tooltip</p-tab>
												<p-tab value="3">YAxis</p-tab>
											</p-tablist>
											<!-- basic -->
											<p-tabpanels>
												<p-tabpanel value="0">
													<div>
														Chart Type:  
														<p-select [options]="chartTypes" 
															[(ngModel)]=singleTS.chartType 
															[style]="{'width':'150px'}" 
															appendTo="body"
															placeholder="Select chart type">
														</p-select>
														<br>
														Symbol: 
														<p-select [options]="symbolTypes" 
															appendTo="body"
															[(ngModel)]=singleTS.symbol 
															editable="true" 
															placeholder="default">
														</p-select><br>
														Color Name or HEX value: <input type="text" pInputText [(ngModel)]=singleTS.color/> 
														Or pick <p-colorPicker [(ngModel)]=singleTS.color> </p-colorPicker>
														<br>
													</div>		
												</p-tabpanel>
												<p-tabpanel value="1">
													<div>
														Series Identifier: 
														<p-select [options]="seriesIdentifierOptions" 
															editable="true" 
															appendTo="body"
															placeholder="default" 
															[(ngModel)]=singleTS.seriesIdentifier 
															[style]="{'width': '250px'}"> 
														</p-select>
														<button pButton pRipple type="button" icon="pi pi-undo" class="p-button-rounded p-button-text p-button-plain topSpacePadding" (click)="resetElement(element, j, 'seriesIdentifier')" title="reset to default"></button><br>
													</div>
												</p-tabpanel>
												<p-tabpanel value="2">
													<div>
														Tooltip Units Precision: <input type="text" pInputText [(ngModel)]=singleTS.tooltipPrecision/>
															<button pButton pRipple type="button" icon="pi pi-undo" class="p-button-rounded p-button-text p-button-plain topSpacePadding" (click)="resetElement(element, j, 'tooltipPrecision')" title="reset to default"></button><br>
													</div>
												</p-tabpanel>
												<p-tabpanel value="3">
													<div>
														Enabled: 
															<p-checkbox [(ngModel)]="singleTS.yAxisEnabled" (onChange)="yAxisEnabledClicked(element, j)" binary="true" [style]="{'position':'relative', 'top': '-8px'}"> </p-checkbox>
															<span id='linkedToGroup' class="leftSpace" [ngClass]="{doNotDisplay:singleTS.yAxisEnabled}">
																Link to: <p-select [options]="element.data[j].linkedToOptions" [(ngModel)]=singleTS.linkedTo
																(onClick)="setElementLinkedToOptions(element, j)" (onChange)="setYAxis(element, j, 'linkedTo', 'linkedTo')"></p-select>
															</span>
															<br>
														<span [ngClass]="{doNotDisplay:!singleTS.yAxisEnabled}">
														YAxis Direction: 
															<p-select [options]="yAxisDirectionOptions" 
																placeholder="default" 
																appendTo="body"
																[(ngModel)]=singleTS.yAxisReversed 
																[style]="{'width': '250px'}" 
																(onChange)="setYAxis(element, j, 'yAxisReversed', 'reversed')"> 
															</p-select>
															<button pButton pRipple type="button" icon="pi pi-undo" class="p-button-rounded p-button-text p-button-plain topSpacePadding" (click)="resetYAxisElement(element, j, 'yAxisReversed', 'reversed')" title="reset to default"></button>
															<br>
														YAxis Label: 
															<p-select [options]="yAxisLabelOptions" 
																editable="true" 
																placeholder="default" 
																appendTo="body"
																[(ngModel)]=singleTS.yAxisLabel 
																[style]="{'width': '250px'}" 
																data-cy="YAxisLabel"> 
															</p-select>
															<button pButton pRipple type="button" icon="pi pi-undo" class="p-button-rounded p-button-text p-button-plain topSpacePadding" (click)="resetElement(element, j, 'yAxisLabel')" title="reset to default"></button><br>
														YAxis Label Units Precision: <input type="number" pInputText [(ngModel)]=singleTS.yAxisLabelPrecision/>
															<button pButton pRipple type="button" icon="pi pi-undo" class="p-button-rounded p-button-text p-button-plain topSpacePadding" (click)="resetElement(element, j, 'yAxisLabelPrecision')" title="reset to default"></button><br>
														</span>
													</div>
												</p-tabpanel>
											</p-tabpanels>
										</p-tabs>
									</p-accordion-content>
								</p-accordion-panel>
							</p-accordion>
							<button pButton pRipple label="Redraw preview" id="redrawPreviewButton" icon="pi pi-refresh" (click)="redrawPreview()"></button>
							<!-- button pButton pRipple id="redrawPreviewButton" class="redrawPreviewButton" (click)="redrawPreview()">Redraw preview</button -->
						</p-panel>
					</div>
				</p-accordion-content>
			
			</p-accordion-panel>
		</p-accordion>
		</div>

		<!-- save buttons -->
		<!-- Currently only 1 save button will be visible at a time -->
		<div style="margin-top: 40px">
			<div class="saveButton">
				<button pButton pRipple id="redrawPreviewButton" label="Redraw Preview" icon="pi pi-refresh" (click)="redrawPreview()"></button>
				<button pButton pRipple id="saveExistingTemplateButton" label="Save Dashboard Edits" icon="pi pi-save" (click)="saveExistingTemplate()"></button>
				<button pButton pRipple id="saveNewTemplateButton" label="Save New Dashboard" icon="pi pi-save" (click)="saveNewTemplate()"></button>
				<button pButton pRipple id="cancelButton" label="Cancel" icon="pi pi-times" (click)="cancelTemplate()"></button>
			</div>
		</div>

	</div>
</div>  <!-- left -->



<div id="right">
		<!-- 
		... preview area ...  -->
		<p-panel [toggleable]="true" id="previewArea" #previewArea header="Preview">
			<dashboard-template-component  style="width: 400px; height: 400px" [isHeaderVisible]="false" [preview]="true" [previewTemplate]="templateElements" [previewTemplateCounter]="previewTemplateCounter" (getStationList)="getStationList($event)" >
			</dashboard-template-component>
		</p-panel>

</div>  <!-- right div -->
</div>  <!-- wrapper -->

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" width="425" #cd>
	<p-footer>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
    </p-footer>
</p-confirmDialog>
